import { connect } from '@atlassian/jira-react-redux';
import { getRunAsUserSaveError } from '../../../../state/selectors/run-as-user';
import type { State as SummaryState } from '../../../../state/types';
import StatefulUserPicker from './stateful-user-picker';
import DialogContent from './view';

const mapStateToProps = (state: SummaryState) => ({
	saveError: getRunAsUserSaveError(state),
	StatefulUserPickerComponent: StatefulUserPicker,
});

export default connect(mapStateToProps, {})(DialogContent);
